/**
 * @typedef {Object} OutputField
 * @property {string} name - Field identifier
 * @property {string|function} label - Display label or function returning label
 * @property {function} [checked] - Function determining if field is selected by default
 * @property {function} [visible] - Function determining if field should be shown
 * @property {boolean} [forceChecked] - If true, field is always selected and cannot be unchecked
 * @property {function} [disabled] - Function determining if fields should be disabled
 */

const billingReportOutputFields = [
  {
    name: "renderingNpi",
    label: "Rendering NPI",
    checked: ({ common }) => !!common.outputs.renderingNpi
  },
  {
    name: "renderingName",
    label: "Rendering Name",
    checked: ({ common }) => !!common.outputs.renderingName
  },
  {
    name: "renderingClassification",
    label: "Rendering Classification",
    checked: ({ common }) => !!common.outputs.renderingClassification
  },
  {
    name: "renderingSpecialization",
    label: "Rendering Specialization",
    checked: ({ common }) => !!common.outputs.renderingSpecialization
  },
  {
    name: "renderingState",
    label: "Rendering State",
    checked: ({ common }) => !!common.outputs.renderingState
  },
  {
    name: "renderingCity",
    label: "Rendering City",
    checked: ({ common }) => !!common.outputs.renderingCity
  },
  {
    name: "renderingZipCode",
    label: "Rendering ZIP Code",
    checked: ({ common }) => !!common.outputs.renderingZipCode
  },

  {
    name: "source",
    label: "Source",
    checked: ({ common }) => !!common.outputs.source
  },

  {
    name: "billingNpi",
    label: "Billing NPI",
    checked: ({ common }) => !!common.outputs.billingNpi
  },
  {
    name: "billingName",
    label: "Billing Name",
    checked: ({ common }) => !!common.outputs.billingName
  },
  {
    name: "billingClassification",
    label: "Billing Classification",
    checked: ({ common }) => !!common.outputs.billingClassification
  },
  {
    name: "billingSpecialization",
    label: "Billing Specialization",
    checked: ({ common }) => !!common.outputs.billingSpecialization
  },
  {
    name: "billingState",
    label: "Billing State",
    checked: ({ common }) => !!common.outputs.billingState
  },
  {
    name: "billingCity",
    label: "Billing City",
    checked: ({ common }) => !!common.outputs.billingCity
  },
  {
    name: "billingZipCode",
    label: "Billing ZIP Code",
    checked: ({ common }) => !!common.outputs.billingZipCode
  },

  {
    name: "distinctClaimsCount",
    label: "Count of Distinct Claims",
    checked: ({ common }) => !!common.outputs.distinctClaimsCount
  },
  {
    name: "distinctPatientsCount",
    label: "Count of Distinct Patients",
    checked: ({ common }) => !!common.outputs.distinctPatientsCount
  },
  {
    name: "proceduresCount",
    label: "Count of Procedures",
    checked: ({ common }) => !!common.outputs.proceduresCount
  },
  {
    name: "sumCharges",
    label: "Sum of Charges",
    checked: ({ common }) => !!common.outputs.sumCharges
  }
];

export default billingReportOutputFields;
